export default "__VITE_PUBLIC_ASSET__3141ba8a__"